import enUS from "./en-us";
import zhCN from "./zh-cn";
export default {
  'en-US': enUS,
  'zh-CN': zhCN
};